<template>
  <v-expansion-panels accordion class="expansion" tile>
    <v-expansion-panel v-for="(tab, index) in tabs" :key="index">
      <v-expansion-panel-header>
        {{ tab.name }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div v-html="tab.content" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
export default {
  name: 'TabsHtmlMobile',
  props: ['tabs']
}
</script>
<style lang="scss" scoped>
.v-expansion-panel-header {
  font-size: 1.6rem;
}
</style>
